import { toast } from "react-toastify";

export const delayMessage = () => {
  toast.error(
    "If your network is good, first request after a long time could take up to a minute",
    { autoClose: 10000 }
  );
};
